"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const material_1 = require("@mui/material");
const lexico_1 = __importDefault(require("@tradeshift/lexico"));
const lexico = new lexico_1.default();
const StyledBox = (0, material_1.styled)(material_1.Box)(({ theme }) => ({
    margin: '0 auto',
    position: 'relative',
    padding: '0',
    zIndex: '2',
    display: 'block',
    '&:nth-of-type(1)': {
        '> *': {
            fontWeight: theme?.typography.tsFontWeight.bold,
        },
        '&::before': {
            content: '""',
            position: 'absolute',
            top: '50%',
            width: '100%',
            height: '1px',
            zIndex: '-1',
            backgroundColor: theme?.palette.tsGoColor.grayLight(),
            display: 'inline-block',
            left: '50%',
            transform: 'translateX(-50%)',
            paddingLeft: theme?.tsGoUnit.tsUnitHalf,
            paddingRight: theme?.spacing(0.5),
            ...(globalThis.cardProvider.IS_HSBC_PROVIDER_SETUP
                ? {
                    content: 'none',
                }
                : {}),
        },
    },
}));
const StyledText = (0, material_1.styled)(material_1.Typography)(({ theme }) => ({
    position: 'relative',
    textAlign: 'center',
    zIndex: '1',
    display: 'inline-block',
    left: '50%',
    transform: 'translateX(-50%)',
    backgroundColor: theme?.palette.tsGoColor.grayLightest,
    paddingLeft: theme?.tsGoUnit.tsUnitHalf,
    paddingRight: theme?.tsGoUnit.tsUnitHalf,
    color: theme?.palette.tsGoColor.grayDark,
    ...(globalThis.cardProvider.IS_HSBC_PROVIDER_SETUP
        ? {
            fontWeight: 500,
            fontSize: '12px',
            color: '#5C5C5C',
            textTransform: 'none',
        }
        : {}),
}));
function getFirstMessage({ event, isUserAuthor }) {
    if (isUserAuthor) {
        return lexico.trc('automated message for a new person added', 'You have been added to the conversation');
    }
    const authorFullName = event.author.fullName || 'N/A';
    // TODO: use lexico after project integration
    return `${authorFullName} has been notified`;
}
const EventNotifier = ({ event, isUserAuthor }) => {
    return ((0, jsx_runtime_1.jsxs)(StyledBox, { style: {
            ...(globalThis.cardProvider.IS_HSBC_PROVIDER_SETUP
                ? {
                    borderTop: '0.5px solid #979797',
                    borderBottom: '0.5px solid #979797',
                }
                : {}),
        }, children: [(0, jsx_runtime_1.jsx)(StyledBox, { mx: 2, children: (0, jsx_runtime_1.jsx)(StyledText, { variant: "body1", children: getFirstMessage({ event, isUserAuthor }) }) }), (0, jsx_runtime_1.jsx)(StyledText, { variant: "body1", style: {
                    ...(globalThis.cardProvider.IS_HSBC_PROVIDER_SETUP
                        ? {
                            fontWeight: 300,
                            fontSize: '12px',
                            color: '#5C5C5C',
                            textTransform: 'none',
                        }
                        : {}),
                }, children: lexico.trc('automated message for a new person added', 'You can now send chat messages back and forth') })] }));
};
exports.default = EventNotifier;
